<template>
    <div class="sales-items sales-items-mobile" v-if="crmProjects != null">
        <div class="sale-item-mobile" v-for="(item, index) in projectItems" :data-name="item.project_name.slug" :data-theme="item.project_card_style_type" :key="item.project_name.slug" :class="{animate : cardAnimate}">
            <div class="inner">
                <component :is="item.project_type_soon == 'true' && item.project_site_type != 'promo' ? 'span' : item.project_type_soon == 'true' && item.project_site_type == 'promo' ? 'router-link' : 'a'" 
                           :href="item.project_type_soon == 'true' && item.project_site_type == 'promo' ? '/sales/promo/' + item.project_name.slug : item.project_site_in.link || ''" 
                           :target="item.project_type_soon != 'true' ? '_blank' : false" 
                           :to="item.project_type_soon == 'true' && item.project_site_type == 'promo' ? '/sales/promo/' + item.project_name.slug : false"
                           class="link-to-page">
                    <div class="item-img">
                        <div class="img-in" :style="'background-image: url(' + item.project_img + ')'"></div>
                        <div class="item-sales-info">
                            <div class="project-theme-list-items" v-if="item.project_them_list != null && item.project_them_list.length > 0">
                                <ul>
                                    <li v-for="(list, index) in item.project_them_list.slice(0, 1)" :key="index" :style="'background-color:' + list.bg"><p :style="'color:' + list.color" v-html="list.desc"></p></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="item-content">
                        <div class="content-in">
                            <div class="item-logo-word">
                                <strong v-html="getCorrectLogoWord(item.project_name.slug)"></strong>
                                <div class="btn-to-favorite" v-if="cardAnimate" :class="{'bank_promo' : item.project_stie_bank_logo_init == 'true', 'bank-promo-ob' : item.project_stie_bank_ob_logo_init == 'true'}">
                                    <a href="#" @click.prevent="sendToFavorite(item.project_name.name), checkerClass($event)" :class="{'active' : checkProjectFavorite(item.project_name.name)}" class="favorite-link">
                                        <svgIcon name="star-sales" class="icon-star"/>
                                    </a>
                                </div>
                            </div>
                            <div class="price-container" v-if="item.project_type_soon != null && item.project_type_soon != 'true'">
                                <div class="price-info" v-if="item.crm_code != null && item.crm_code != '' && item.project_stie_shablon_price_flats_init == 'true' && crmProjects != null && getCRMprojectInfo(item.crm_code, 'price') != false">
                                    <div class="price-num"><p><span>от</span> {{getCRMprojectInfo(item.crm_code, 'price')}} <span>тг/м²</span></p></div>
                                    <a href="#" @click.prevent="navigationToFlatsFilter(item.crm_code) " v-if="item.project_stie_flats_filter_init == 'true'">
                                        <span v-if="globalLang == ''">КВАРТИРЫ</span>
                                        <span v-if="globalLang == 'kz/'">ПӘТЕРЛЕР</span>
                                        <span v-if="globalLang == 'en/'">Layouts</span>
                                        <svgIcon name="arrow-go-right"/>
                                    </a>
                                    <a :href="item.project_site_in.link" target="_blank" v-else>
                                        <span v-if="globalLang == ''">Смотреть</span>
                                        <span v-if="globalLang == 'kz/'">Толығырақ</span>
                                        <span v-if="globalLang == 'en/'">Details</span>
                                        <svgIcon name="arrow-go-right"/>
                                    </a>
                                </div>
                                <div class="price-info-not-allowed" v-else>
                                    <div class="price-num"><p>Цена по запросу</p></div>
                                    <a :href="item.project_site_in.link" target="_blank">
                                        <span v-if="globalLang == ''">Смотреть</span>
                                        <span v-if="globalLang == 'kz/'">Толығырақ</span>
                                        <span v-if="globalLang == 'en/'">Details</span>
                                        <svgIcon name="arrow-go-right"/>
                                    </a>
                                </div>
                            </div>
                            <div class="form-soon-container" v-if="item.project_type_soon != null && item.project_type_soon == 'true'">
                                <div class="btn-to-login">
                                    <a href="#" @click.prevent="openForm(item)">
                                        <span v-if="globalLang == ''">Зарегистрироваться</span>
                                        <span v-if="globalLang == 'kz/'">Тіркелу</span>
                                        <span v-if="globalLang == 'en/'">Register</span>
                                        <svgIcon name="arrow-go-right"/>
                                    </a>
                                </div>
                            </div>
                            <div class="adress-container">
                                <div class="adres" :class="getClass(item)">
                                    <div v-html="item.project_adres"></div>
                                </div>
                                <div class="banks-logos">
                                    <div class="logo-item" v-if="item.project_stie_bank_ob_logo_init == 'true'"><img :src="setup.logo_ob_bank" alt=""></div>
                                    <div class="logo-item" v-if="item.project_stie_bank_logo_init == 'true'"><img :src="setup.logo_cc_bank" alt=""></div>
                                    <div class="logo-item" v-if="item.project_stie_bank_halyk_logo_init == 'true'"><img :src="setup.logo_halyk_bank" alt=""></div>
                                    <div class="logo-item" v-if="item.project_stie_bank_altyn_logo_init == 'true'"><img :src="setup.logo_altyn_bank" alt=""></div>
                                    <div class="logo-item" v-if="item.project_stie_bank_rbk_logo_init == 'true'"><img :src="setup.logo_rbk_bank" alt=""></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </component>
                <!-- <formSignupProject  :options="[{project_name: item.project_name.name, 'index' : index }]"></formSignupProject> -->
            </div>
        </div>
    </div>
</template>

<script>
    // import formSignupProject from '@/components/forms/form-signup-project.vue'
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';

    export default {
        name: 'sale-item',
        components: {
            // formSignupProject,
            svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                routerName: this.$router.history.current.name,
                banerArr: null,
                isMobile: false,
            }
        },
        computed: mapGetters({
            projectItems: 'loadProjectItems',
            cardAnimate: 'loadCardAnimateStatus',
            projectItemsDefault: 'loadProjectItemsDefault',
            projectFilterCity: 'loadProjectItemsFilterCity',
            crmProjects: 'loadCrmProjects',
            setup: 'loadPageSetUp',
            salesFilterParams: 'loadSalesFilterParams',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            getCRMprojectInfo(id, key) {
                var arr = this.crmProjects;
                var result;
                // console.log(key, 'key')
                // console.log(arr, 'arr');
                // console.log(id, 'id')
                if (id != null) {
                    var filter = arr.filter(item => {
                        return item.code == id
                    });
                    if (filter.length > 0) {
                        if (key == 'price') {
                            if (filter[0].minMeterPrice != 0 && filter[0].minMeterPrice != null && filter[0].minMeterPrice != undefined) {
                                result = this.getNumber(filter[0].minMeterPrice);
                            } else {
                                return false;
                            }
                            
                        } else {
                            if (filter[0].apartmentsQuantity != 0 && filter[0].apartmentsQuantity != null && filter[0].apartmentsQuantity != undefined) {
                                result = filter[0].apartmentsQuantity;
                            } else {
                                return false;
                            }
                        }
                        return result;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            },
            sendToFavorite(name) {
                // console.log(name, 'NAME');
                // Получаем уже хранившиеся комплексы если есть из LocalStorage
                var exist = localStorage.getItem('favorite_projects');
                exist = exist ? exist.split(',') : [];
                // Проверяем есть ли уже такое имя в Storage
                var finder = exist.find(item => item == name);
                // console.log(finder, 'НАЛИЧИЕ');

                if (finder == undefined) {
                    exist.push(name);
                    localStorage.setItem('favorite_projects', exist);
                    this.$store.commit('setFavoriteCount', exist.length);
                    // console.log(exist);
                } else {
                    var filterExist = exist.filter(item => {
                        return item != name
                    })
                    localStorage.setItem('favorite_projects', filterExist);
                    this.$store.commit('setFavoriteCount', filterExist.length);
                    // console.log(filterExist);
                }
            },
            checkProjectFavorite(name) {
                var items = localStorage.getItem('favorite_projects');
                items = items ? items.split(',') : [];
                this.$store.commit('setFavoriteCount', items.length);
                var finder = items.find(item => item == name);
                // console.log(finder)
                if (finder != undefined) {
                    return true
                } else {
                    return false
                }
            },
            checkerClass(event) {
                event.currentTarget.classList.toggle('active');
                // Фильтр для избранных
                if (this.routerName == 'favorite-projects') {
                    var data = this.projectItemsDefault;
                    var favorite = localStorage.getItem('favorite_projects');
                    favorite = favorite ? favorite.split(',') : [];
                    var i;
                    var n;
                    var favoriteItems = [];
                    for (i=0; i < favorite.length; i++) {
                        for (n=0; n < data.length; n++) {
                            if (data[n].project_name.name == favorite[i]) {
                                favoriteItems.push(data[n])
                            }
                        }
                    }
                    this.$store.commit('cardAnimateSet', false);
                    setTimeout(()=>{
                        this.$store.commit('filterProjectsItems', favoriteItems);
                        this.$store.commit('cardAnimateSet', true);
                    },50);
                }
            },
            checkForSite(name, arr) {
                // console.log(name);
                // console.log(arr);

                // this.$router.push({name : 'sales-app' , params:{id : name} });
                if (arr.project_site_type != null && arr.project_site_type == 'link') {
                    window.open(arr.project_site_in.link, '_blank');
                } else if (arr.project_site_type != null) {
                    this.$router.push({name : 'sales-app' , params:{id : name} })
                } else  {
                    return false;
                }
                // if (arr.turn_on_inside_page == 'false') {
                //     if (arr.project_site.init == 'true') {
                //         window.open(arr.project_site.link, '_blank');
                //     } else {
                //         return false;
                //     }
                // } else if (arr.turn_on_inside_page == 'true') {
                //     
                // } else {
                //     return false;
                // }
            },
            openLinkLogo(arr) {
                if (window.innerWidth > 1024) {
                    if (arr.turn_on_inside_page == 'false') {
                        if (arr.project_site.init == 'true') {
                            window.open(arr.project_site.link, '_blank');
                        } else {
                            return false;
                        }
                    } else if (arr.turn_on_inside_page == 'true') {
                        this.$router.push({name : 'sale-card' , params:{id : name} })
                    } else {
                        return false;
                    }
                }
            },
            openForm(arr) {
                this.$store.commit('setDataToSignupModal', arr);
                this.$modal.show('form-modal-signup');
                // console.log(index);
                // this.$store.commit('Open_form_SignUp_Project', index);
                // console.log(this.$store.state.isOpenFormSignUpProject, 'AJAX')
            },
            navigationToFlatsFilter(code) {
                this.$router.push({ path: 'flats', query: { 'complex-code' : code } })
            },
            getConsultation() {
                var data = {
                    'city': this.currentCityArr[0].region,
                    'page': 'sales',
                    'page_key': 'sales',
                }
                this.$store.commit('getFormConsultData', data);
                this.$store.commit('Open_form_Consult', true);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
                // console.log(data);
            },
            getCorrectLogoWord(word) {
                // console.log(word, 'asdasdas')
                if (word == 'orion-3') {
                    return word.replace('-', ' ').replace('3', '<span class="orion-word">III</span>')
                } else if (word == 'jazzkvartal') {
                    return 'JAZZ KVARTAL'
                } else if (word == 'auezovcity') { 
                    return 'AUEZOV CITY'
                } else if (word == 'auezov-city-pro') { 
                    return 'AUEZOV CITY PRO'
                } else if (word == 'belyy-ostrov') { 
                    return 'БЕЛЫЙ ОСТРОВ'
                } else if (word == 'jandostar') { 
                    return 'JAN DOSTAR'
                } else if (word == 'lmgold') { 
                    return 'LANDMARK GOLD'
                } else {
                    return word.replace('-', ' ');
                }
            },
            getClass(item) {
                const trueArr = [];
                trueArr.push(
                    item.project_stie_bank_halyk_logo_init,
                    item.project_stie_bank_logo_init,
                    item.project_stie_bank_ob_logo_init,
                    item.project_stie_bank_rbk_logo_init,
                    item.project_stie_bank_altyn_logo_init,
                );
                
                const trueCount = trueArr.filter(item => {
                    return item == 'true'
                });
                // console.log(trueCount.length)
                if (trueCount.length != 0) {
                    return 'adres-type-' + trueCount.length;
                } else {
                    return 'adres-standart';
                }
            },  
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.isMobile = true
                }
            },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.isMobile = true
                } else {
                    this.isMobile = false
                }
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.isMobileCheck();
            this.handleResize();
            this.checkResize();
            // this.$store.watch(
            //     (state) => state.projectItemsFilterCity,
            //     (newValue) => {
            //     }
            // )
        }
    }
</script>

<style lang="scss">
    // @import '@/styles/components/sales/sale-item-new.scss';
    @import '@/styles/respond/sales/respond-sale-item-new.scss';
</style>